import React from "react";
import Axios from 'axios'
import CircularDeterminate from "../_Components/CircularDeterminate";
import MasterTemplate from "./MasterTemplate";
import Cleave from "cleave.js/react"
import moment from 'moment';

export default class GerarLote extends React.Component {
  constructor(props) {
    window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("user")),
      quantidade: 0,
      dataSorteio: new Date(),
      horario: '00:00',
      generate: false,
      historico: {
        dataSorteio: new Date(),
        qtdCartelasLote: 0
      },
      historicos: [],
      cartelas: [],
      allLotes: [],
      sorteioStatus: true
    };
    this.getSorteioStatus();
    this.setValor = this.setValor.bind(this);
    this.setHorario = this.setHorario.bind(this);
    this.setQuantidade = this.setQuantidade.bind(this);
    this.generateLote = this.generateLote.bind(this);
    this.deletarLote = this.deletarLote.bind(this);
    this.setDataSorteio = this.setDataSorteio.bind(this)
    this.ultimoHistorico()
    this.listarHistoricos()
    this.listarAllLotes()
  }

  componentDidMount() {

  }

    getSorteioStatus = async () => {
          try {
            var axiosInstance = new Axios.create({
              baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("parametros/obter-sorteio-status");
              this.setState({sorteioStatus : response.data.sorteioStatus});
          } catch (error) {
              console.log(error);
          }
    }

  async replicarLotes() {
    if (this.state.quantidade == 0) {
      alert("Selecione a quantidade de cartelas!")
      return;
    }
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("lotesDB/replicar-lotes", {
        quantidade: this.state.quantidade,
        valor: this.state.valor,
        masterId: this.state.user._id,
        dataSorteio: this.state.dataSorteio,
        horario: this.state.horario,
      });
      this.atualizarValorCartela(this.state.valor);
      this.listarAllLotes();
    } catch (err) {
      console.log(err);
    }
  }

  compararCodigo(a, b) {
    if (a.codigo > b.codigo) {
      return 1;
    }
    if (a.codigo < b.codigo) {
      return -1;
    }

    return 0
  }

  deletarDuplicadas() {

    this.state.allLotes.map(lote => {
      var cartelasIndexDeletar = []
      var auxLote = lote;
      lote.cartelas.sort(this.compararCodigo).map((cartela, index) => {

        var ultimoIndex = lote.cartelas.sort(this.compararCodigo)[index - 1];
        var proxIndex = lote.cartelas.sort(this.compararCodigo)[index + 1];
        var cartelaAtual = lote.cartelas.sort(this.compararCodigo)[index];

        if (ultimoIndex != undefined && proxIndex != undefined) {
          console.log(cartelaAtual.codigo)
          if (ultimoIndex.codigo == cartelaAtual.codigo || proxIndex.codigo == cartelaAtual.codigo) {

            cartelasIndexDeletar.push(index)
          }
        }
      })

      cartelasIndexDeletar.map(numero => {
        lote.cartelas.sort(this.compararCodigo)[numero] = null
      })

      auxLote.cartelas.map((cartela, index) => {
        if (lote.cartelas[index] == null)
          lote.cartelas.splice(index, 1)
      })

      this.atualizarLote(lote)
    })

  }

  async atualizarLote(lote) {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("lotes/atualizar-lote", { _id: lote._id, cartelas: lote.cartelas });
      console.log(response.data)

    } catch (err) {
      console.log(err);
    }
  }


  formatDate(data) {
    return moment(data).add(0, 'days').format('DD-MM-YYYY')
  }

  numberToReal(numero) {
    numero = numero.replace(/\D/g, "");
    numero = new String(Number(numero));
    var len = numero.length;
    if (1 == len)
      numero = numero.replace(/(\d)/, "0.0$1");
    else if (2 == len)
      numero = numero.replace(/(\d)/, "0.$1");
    else if (len > 2) {
      numero = numero.replace(/(\d{2})$/, '.$1');
    }
    return numero;
  }

  setHorario(e) {
    this.setState({ horario: e.target.value })
  }

  setDataSorteio(event) {
    this.setState({ historico: { ...this.state.historico }, dataSorteio: event.target.value })
  }
  setValor(event) {
    this.setState({ historico: { ...this.state.historico, valorCartelasLote: Number(this.numberToReal(event.target.value)).toFixed(2) }, valor: Number(this.numberToReal(event.target.value)).toFixed(2) });
  }
  setQuantidade(event) {
    if (parseInt(event.target.value) == 0) {
      alert("Selecione a quantidade de cartelas!")
    }
    else {
      this.setState({ historico: { ...this.state.historico, qtdCartelasLote: parseInt(event.target.value) }, quantidade: parseInt(event.target.value)  });
    }
  }
  getUser = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("usuarios/user", {
        id: this.state.user._id
      });

      window.localStorage.setItem("user", JSON.stringify(response.data[0]));
      this.setState({ user: response.data[0] });
    } catch (err) {
      console.log(err);
    }
  };

  listarHistoricos = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.get("historicos/", {});

      this.setState({ historicos: response.data.sort(this.compararDatas) });
    } catch (err) {
      console.log(err);
    }
  };

  compararDatas(a, b) {
    var A = new Date(a.dataInicial)
    var B = new Date(b.dataInicial)
    if (A < B) {
      return 1;
    }
    if (A > B) {
      return -1;
    }

    return 0
  }


  criarHistorico = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("historicos/criar-historico", { ...this.state.historico });
      this.setState({ historico: response.data });
    } catch (err) {
      console.log(err);
    }
  };

  ultimoHistorico = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.get("historicos/ultimo-historico", {});
      this.setState({ historico: response.data });
    } catch (err) {
      console.log(err);
    }
  };
  atualizarHistorico = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("historicos/atualizar-historico", { ...this.state.historico });
    } catch (err) {
      console.log(err);
    }
  };

  fecharHistorico = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("historicos/fechar-ultimo-historico", {});
    } catch (err) {
      console.log(err);
    }
  };

  async deletarLote2() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.get("lotes/delete", {});
    } catch (err) {
      console.log(err);
    }
  };



  deletarLote = async (e) => {
    e.target.disabled = true
    alert("Ao deletar os clientes não irão ver seus pedidos anteriores na aba MINHAS CARTELAS")
    this.fecharHistorico()
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.get("lotes/delete", {});

      this.setState({ lote: null });
      this.deletarSerie()
      this.fecharPedidos()
      this.fecharTransacoes()
      alert("VOCÊ DELETOU O LOTE ATUAL DE CARTELAS");
    } catch (err) {
      console.log(err);
    }
  };

  fecharPedidos = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("pedidos/fechar-pedidos", {});
    } catch (err) {
      console.log(err);
    }
  };

  fecharTransacoes = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("transacoes/fechar-transacoes", {});
    } catch (err) {
      console.log(err);
    }
  };

  deletarSerie = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.get("series/delete", {});

    } catch (err) {
      console.log(err);
    }
  };


  gerarLote = async (e) => {
    if (this.state.quantidade == 0) {
      alert("Selecione a quantidade de cartelas!")
      return;
    }
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("lotes/criar-lote", {
        quantidade: this.state.quantidade,
        valor: this.state.valor,
        masterId: this.state.user._id,
        dataSorteio: this.state.dataSorteio,
        horario: this.state.horario,
      });
      this.atualizarValorCartela(this.state.valor);
      this.listarAllLotes();
    } catch (err) {
      console.log(err);
    }
  };

  async desbloquearVenda() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("parametros/desbloquea-venda", {});
    } catch (err) {
      console.log(err);
    }
  }

  async atualizarValorCartela(valor) {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("parametros/set-valor-cartela", {valor: valor});
    } catch (err) {
      console.log(err);
    }
  }

  generateLote(e) {
    e.target.disabled = true
    if (this.state.quantidade && this.state.valor) {
      this.criarHistorico()
      this.desbloquearVenda()
      this.setState({ generate: true });
      this.replicarLotes();
    } else {
      alert("Todos os campos devem ser preenchidos antes de gerar");
    }
  }

  async listarAllLotes() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.get("lotes/all-lotes", {
      });
      this.setState({ allLotes: response.data })
    } catch (err) {
      console.log(err);
    }
  }

  resumirLotes() {
    var valorDaCartela = 0;
    var cartelasRestantes = 0;
    var data = new Date()
    if (this.state.allLotes) {
      this.state.allLotes.map(lote => {
        if (lote.cartelas.length > 0) {
          valorDaCartela = lote.cartelas[0].valor;
          cartelasRestantes += lote.cartelas.length;
          data = lote.data;
        }
      }
      )
    }
    return { valorDaCartela, cartelasRestantes, data }
  }

  render() {
    var { data, valorDaCartela, cartelasRestantes } = this.resumirLotes()
    return (
      <MasterTemplate label="Geração de cartelas" >
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8 ml-auto mr-auto">
              <div className="card">
                <div className="header text-center">
                  <h4 className="title">Gerar cartelas</h4>
                  <p className="category">
                    Atenção, esse recurso pode demorar alguns minutos.
                  </p>
                  <br />
                  <p className="category">
                    Quantidade maxima: <span className="text-danger">100.000</span>
                  </p>
                  {this.state.generate ? (
                    <CircularDeterminate
                      geraLote={true}
                      max={100}
                    ></CircularDeterminate>
                  ) : (
                    ""
                  )}
                </div>
                <div className="content table-responsive table-upgrade">
                  <table className="table">
                    <thead>
                      <tr>
                        <th></th>
                        <th className="text-center"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-center">
                          Quantidade de cartelas
                        </td>
                        <td>

                          <select class="custom-select" onChange={this.setQuantidade} disabled={this.state.allLotes.length > 0 ? true : false}>
                            <option value="0"  >Selecione</option>
                            <option value="50000">50.000</option>
                            <option value="100000">100.000</option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-center">Data do sorteio</td>
                        <td >
                          <input class="form-control" disabled={this.state.allLotes.length > 0 ? true : false} type="date" onChange={this.setDataSorteio} />
                        </td>
                      </tr>
                      <tr>
                        <td className="text-center">Horário</td>
                        <td >
                          <Cleave disabled={this.state.allLotes.length > 0 ? true : false} placeholder="00:00"
                            data-length="5"
                            className={`form-control`}
                            options={{
                              numericOnly: true,
                              delimiters: [':'],
                              blocks: [2, 2]
                            }}
                            value={this.state.horario || ''}
                            onChange={this.setHorario}
                          />

                        </td>
                      </tr>
                      <tr>
                        <td className="text-center">Valor por cartela</td>
                        <td>
                          <input maxLength="5" value={this.state.valor} disabled={this.state.allLotes.length > 0 ? true : false}
                            className="form-control w-100" placeholder="valor" onChange={this.setValor} />
                        </td>
                      </tr>
                      
                      <tr className="last-row">
                        {this.state.sorteioStatus? 
                        
                        <td>
                        {" "}
                        <button
                          disabled={this.state.allLotes.length > 0 ? false : true}
                          onClick={() => {alert("É necessario finalizar o sorteio antes de excluir um lote!")}}

                          className="btn btn-round btn-fill btn-danger"
                        >
                          Excluir lote atual
                        </button>
                      </td>
                        
                        :
                        
                        <td>
                        {" "}
                        <button
                          disabled={this.state.allLotes.length > 0 ? false : true}
                          onClick={this.deletarLote.bind(this)}

                          className="btn btn-round btn-fill btn-danger"
                        >
                          Excluir lote atual
                        </button>
                      </td>
                        
                        }
   
                        {this.state.sorteioStatus?
                         <td>
                         <button
                           disabled={this.state.allLotes.length > 0 ? true : false}
                           onClick={() => {alert("É necessario finalizar o sorteio antes de gerar um lote!")}}
                           className="btn btn-round btn-fill btn-info"
                         >
                           Gerar lote
                         </button>
                        </td>                       
                        
                        :
                        <td>
                        <button
                          disabled={this.state.allLotes.length > 0 ? true : false}
                          onClick={this.generateLote.bind(this)}
                          className="btn btn-round btn-fill btn-info"
                        >
                          Gerar lote
                        </button>
                        </td>            
                        }

                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="text-center card-body table-full-width table-responsive">
                  <span class="font-weight-bold">LOTE VIGENTE</span>
                  <table class="table table-hover table-striped">
                    <thead>
                      <tr>
                        <th>Data</th>
                        <th>Cartelas restantes</th>
                        <th>Valor por cartela</th>
                      </tr>
                    </thead>
                    <tbody>{

                      <tr
                        class=
                        "font-weight-bold "
                      >
                        <td>{this.formatDate(data)}</td>
                        <td>{cartelasRestantes}</td>
                        <td>{"R$: " + parseFloat(valorDaCartela).toFixed(2)}</td>
                      </tr>

                    }

                    </tbody>
                  </table>
                </div>

                <div class="text-center card-body table-full-width table-responsive">
                  <span class="font-weight-bold">Historicos</span>
                  <table class="table table-hover table-striped">
                    <thead>
                      <tr>
                        <th>Data inicial</th>
                        <th>Data final</th>
                        <th>Lote gerado</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.historicos.length > 0 ?
                        this.state.historicos.map(historico => {
                          return (
                            <tr class="font-weight-bold ">
                              <td>{this.formatDate(historico.dataInicial)}</td>
                              <td>{this.formatDate(historico.dataFinal)}</td>
                              <td>{historico.qtdCartelasLote}</td>
                            </tr>

                          )
                        })


                        : ""}




                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MasterTemplate>
    );
  }
}
